module.exports = __webpack_public_path__ + "static/media/icon-happiness.5eb28589.svg";